import numeral from "numeral"

// ----------------------------------------------------------------------
if (!numeral.locales["nl"]) {
  numeral.register("locale", "nl", {
    delimiters: {
      thousands: ".",
      decimal: ",",
    },
    abbreviations: {
      thousand: "k",
      million: "mln",
      billion: "mrd",
      trillion: "bln",
    },
    ordinal: function (number) {
      const remainder = number % 100
      return (number !== 0 && remainder <= 1) || remainder === 8 || remainder >= 20 ? "ste" : "de"
    },
    currency: {
      symbol: "€ ",
    },
  })
}

numeral.locales["en"].currency.symbol = "€ "

numeral.locale("nl")

export function fNumber(number: string | number, formatting = "0.00"): string {
  return numeral(number).format(formatting)
}

export function fCurrency(number: string | number, formatting = `$0,0`): string {
  const format: string = numeral(number).format(formatting)

  return format
}

export function fPercent(number: string | number, formatting = "0.0%"): string {
  const format = number ? numeral(number).format(formatting) : ""

  return format
}

export function fShortenNumber(number: string | number): string {
  const format = number ? numeral(number).format("0.00a") : ""

  return format
}

export function fData(number: string | number): string {
  const format = numeral(number).format("0.0 b")

  return result(format, ".0")
}

export function stringToNumber(value: string): number | null {
  return numeral(value).value()
}

function result(format: string, key = ".00"): string {
  const isInteger = format.includes(key)

  return isInteger ? format.replace(key, "") : format
}

export function setLocale(locale: string) {
  numeral.locale(locale)
}
